/**
 * 包版本管理配置
 */

// 需要动态更新版本的自有包列表
export const PACKAGES_TO_UPDATE = [
  '@verve-kit/react-script',
  // 可以在这里添加更多需要动态更新的自有包
];
